module.exports = __webpack_public_path__ + "img/tools_meetings_768.b884470.jpg";